import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { CompanyContext } from 'common/containers/CompanyContainer';
import companyOGImage from 'common/util/companyOGImage';
import getCannyOrigin from 'common/util/getCannyOrigin';
import removeMarkdownLinks from 'common/util/removeMarkdownLinks';
import withContexts from 'common/util/withContexts';

import Helmet from './Helmet';

@withContexts({ company: CompanyContext })
export default class BoardHomeHelmet extends Component {
  static propTypes = {
    board: PropTypes.shape({
      name: PropTypes.string,
      strings: PropTypes.shape({
        description: PropTypes.string,
      }),
    }),
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
  };

  render() {
    const { board, company } = this.props;
    if (!board || !board.name || !company.name) {
      return null;
    }

    const title = `${board.name} | ${company.name}`;
    const url = getCannyOrigin(company) + '/' + board.urlName;
    return (
      <Helmet
        title={title}
        link={[{ href: url, rel: 'canonical' }]}
        meta={[
          { name: 'description', content: removeMarkdownLinks(board.strings.description) },
          { property: 'og:image', content: companyOGImage(company._id) },
          { property: 'og:description', content: removeMarkdownLinks(board.strings.description) },
          { property: 'og:title', content: title },
        ]}
      />
    );
  }
}
